import React, { useState } from 'react';
import Icon from '../Icon';
import HealthMetricsPanel from './HealthMetricsPanel';
import CalculatorsPanel from './CalculatorsPanel';
import GoalsPanel from './GoalsPanel';
import MedicationsPanel from './MedicationsPanel';

const TABS = [
  { key: 'metrics', label: 'My Health Metrics', icon: 'straighten' },
  { key: 'calculators', label: 'Health Calculators', icon: 'calculate' },
  { key: 'goals', label: 'My Wellbeing Goals', icon: 'flag' },
  { key: 'medications', label: 'My Medications', icon: 'medication' },
];

export default function WellbeingProfile() {
  const [tab, setTab] = useState(null);

  return (
    <section className="w-full px-margin-mobile lg:px-margin pb-space-2xl" id="my-wellbeing-profile" data-testid="wellbeing-profile">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-space-lg gap-space-sm">
        <div>
          <span className="font-label-md text-label-md uppercase tracking-widest text-primary font-bold">Your Private Profile</span>
          <h2 className="font-headline-md text-headline-md tracking-tight text-outline">My Wellbeing Space</h2>
        </div>
        <p className="font-body-sm text-body-sm text-on-surface-variant max-w-md md:text-right">
          Open a section whenever you’re ready. Everything here is private to your account, and nothing is required.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-space-md mb-space-lg">
        {TABS.map((t) => {
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              type="button"
              data-testid={`profile-tab-${t.key}`}
              aria-expanded={active}
              onClick={() => setTab(active ? null : t.key)}
              className={`p-space-md rounded-xl border text-left transition-all flex items-center gap-space-md ${active ? 'bg-outline text-surface border-outline shadow-md' : 'bg-surface-container-lowest border-surface-container hover:border-surface-tint/50 shadow-sm'}`}
            >
              <span className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${active ? 'bg-surface-tint text-on-primary' : 'bg-primary-container text-surface-tint'}`}>
                <Icon name={t.icon} className="text-[20px]" />
              </span>
              <span className="flex-1 min-w-0">
                <span className={`font-title-md text-body-md font-semibold block leading-snug ${active ? 'text-surface' : 'text-outline'}`}>{t.label}</span>
                <span className={`font-label-sm text-label-sm uppercase tracking-wider ${active ? 'text-primary-fixed' : 'text-on-surface-variant'}`}>
                  {active ? 'Open' : 'Tap to open'}
                </span>
              </span>
            </button>
          );
        })}
      </div>

      {tab === 'metrics' && <HealthMetricsPanel />}
      {tab === 'calculators' && <CalculatorsPanel />}
      {tab === 'goals' && <GoalsPanel />}
      {tab === 'medications' && <MedicationsPanel />}
    </section>
  );
}
